itsoftApp.createModule("video", function () {
    const module = this;

    const initVideo = function (videoEl) {
        const videoBlockWrapper = videoEl.querySelector(".js-video-container");
        const videoItem = videoEl.querySelector(".js-video-item");
        const playButton = videoEl.querySelector(".js-button-play");

        var onVideoPlay = function () {
            var playPromise = videoItem.play();
            videoItem.classList.add("js-active");
            videoBlockWrapper.classList.add("js-active");
        }

        playButton.addEventListener("click", onVideoPlay);
    }

    module.initVideo = initVideo;
});